import { Stack, Typography } from '@mui/material'
import LocalPlayIcon from '@mui/icons-material/LocalPlay'

export const OnboardingReferralBanner: Settle.FC = ({ children, ...props }) => (
  <Stack
    {...props}
    sx={(theme) => ({
      borderRadius: '5px',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(1, 1.5, 1, 1),
      backgroundColor: theme.tokens.ThemeColorCommonPrimaryContainer,
    })}
  >
    <LocalPlayIcon color="secondary" />
    <Typography variant="body2">{children}</Typography>
  </Stack>
)
